<template>
    <div class="row">
        <div class="col">
            <search scope="mine"></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from '../data/states/Result'
    import Search from '../data/states/Search'

    export default {
    
        components: {
            Search, Result
        }
    }
</script>
